import styled from 'styled-components';
import { Card, Form } from 'antd';

export const StyledCard = styled(Card)`
  width: 500px;
  z-index: 10;
`;

export const StyledForm = styled(Form)`
  max-width: 600px;
`;

export const StyledFormItem = styled(Form.Item)`
  text-align: center;
`;
